import { computed, onMounted, onUnmounted, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

const ACTIVITY_EVENTS = [
  'mousemove',
  'keydown',
  'click',
  'scroll',
  'touchstart',
];

export function useInactivityTimer() {
  const store = useStore();
  const { currentAccount, accountId } = useAccount();

  const timeoutMinutes = computed(() => {
    const value = currentAccount.value?.settings?.user_inactivity_timeout;
    const parsed = parseInt(value, 10);
    if (!parsed || parsed < 1 || parsed > 60) return null;
    return parsed;
  });

  const currentAvailability = computed(
    () => store.getters.getCurrentUserAvailability
  );

  let inactivityTimer = null;

  const clearInactivityTimer = () => {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
      inactivityTimer = null;
    }
  };

  const setUserOffline = () => {
    if (currentAvailability.value === 'offline') return;

    store.dispatch('updateAvailability', {
      availability: 'offline',
      account_id: accountId.value,
    });
  };

  const resetInactivityTimer = () => {
    clearInactivityTimer();
    if (!timeoutMinutes.value) return;

    inactivityTimer = setTimeout(
      setUserOffline,
      timeoutMinutes.value * 60 * 1000
    );
  };

  const handleActivity = () => {
    resetInactivityTimer();
  };

  const startTracking = () => {
    if (!timeoutMinutes.value) return;

    ACTIVITY_EVENTS.forEach(event =>
      document.addEventListener(event, handleActivity, { passive: true })
    );
    resetInactivityTimer();
  };

  const stopTracking = () => {
    ACTIVITY_EVENTS.forEach(event =>
      document.removeEventListener(event, handleActivity)
    );
    clearInactivityTimer();
  };

  watch(timeoutMinutes, () => {
    stopTracking();
    startTracking();
  });

  onMounted(() => {
    startTracking();
  });

  onUnmounted(() => {
    stopTracking();
  });
}
